import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight, Home } from "lucide-react";

/**
 * Purpose: friendly 404 shown by the catch-all route so an unknown URL never
 * renders a blank white screen.
 */
export default function NotFound() {
  return (
    <div className="bg-background min-h-[70vh] grid place-items-center px-6 text-center" data-testid="not-found-page">
      <div className="max-w-lg">
        <span className="mx-auto mb-6 grid h-20 w-20 place-items-center rounded-3xl bg-gradient-to-br from-primary/15 to-primary/5 ring-1 ring-primary/10 text-primary shadow-sm animate-float-soft">
          <Compass className="h-10 w-10" />
        </span>
        <p className="text-xs font-black uppercase tracking-[0.28em] text-muted-foreground mb-2">Error 404</p>
        <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter text-primary">Page not found</h1>
        <p className="text-muted-foreground mt-4 max-w-md mx-auto">
          The page you are looking for was moved, removed, or never existed. Let's get you back on track.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground shadow hover:opacity-90 transition">
            <Home className="h-4 w-4" /> Back to home
          </Link>
          <Link to="/properties" className="inline-flex items-center justify-center gap-2 rounded-md border border-border bg-background px-5 py-2.5 text-sm font-bold hover:bg-muted transition">
            Browse properties <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
